import React from 'react'

import { COLORS, styled } from '../../theme'
import { computeStatusPropsFromOptionItem, E2eTag } from '../../utils'
import { Status } from '../Status'
import { Typography } from '../Typography'

const OptionWrapper = styled('div')`
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
  gap: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

const StyledTypography = styled(Typography)`
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  white-space: nowrap;
  margin: 0;
`

const StyledTypographyRight = styled(Typography)`
  display: flex;
  margin-left: auto;
  font-weight: bold;
`

type OptionItemProps = { label: string; icon?: string; color?: string; rightLabel?: string } & E2eTag

export const OptionItemComponent = ({
  label,
  icon,
  color,
  'data-test-id': dataTestId,
  rightLabel,
}: OptionItemProps) => {
  const statusProps = computeStatusPropsFromOptionItem({ icon, fontColor: color })

  return (
    <OptionWrapper>
      <Status {...statusProps}>{label}</Status>
      {rightLabel != null && (
        <StyledTypographyRight variant="body1" color={COLORS.text.secondary} data-test-id={dataTestId}>
          {rightLabel}
        </StyledTypographyRight>
      )}
    </OptionWrapper>
  )
}
